import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=2624e126&scoped=true"
import script from "./Browser.vue?vue&type=script&lang=js"
export * from "./Browser.vue?vue&type=script&lang=js"
import style0 from "./Browser.vue?vue&type=style&index=0&id=2624e126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2624e126",
  null
  
)

export default component.exports